import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { H1 } from '../general';
import SplashBullets from '../general/styled/SplashBullets';
import Splash from '../../layouts/Splash';

const StyledHeader = styled.div`
  margin-bottom: 20px;

  h1 {
    font-family: 'Inter', serif;
    color: white;
  }
`;

const StyledSubHeader = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  max-width: 400px;
  color: white;
  margin: 0 auto;
`;

const LoginSplash = () => {
  const { t } = useTranslation();
  const bullets = [t('Monitor your home solar system'), t('Make payments or view billing history'), t('Manage your account & preferences')];
  return (
    <Splash>
      <StyledHeader>
        <H1>{t('Hello, Sunshine!')}</H1>
      </StyledHeader>
      <StyledSubHeader>{t('Welcome to mySunrun, your partner in all things home solar.')}</StyledSubHeader>
      <SplashBullets bullets={bullets} />
    </Splash>
  );
};

export default LoginSplash;
